<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="text"
    track-by="value"
    :options="options"
    :searchable="false"
    :disabled="!editable"
    :allow-empty="false">
    <template slot="singleLabel"
              slot-scope="props">
      <div class="option__desc"
           :style="'color:'+props.option.color">
        {{ props.option.text }}
      </div>
    </template>
    <template slot="option"
              slot-scope="props">
      <div class="option__desc"
           :style="'color:'+props.option.color">
        {{ props.option.text }}
      </div>
    </template>
    <template #placeholder>
      {{ $t('common.SelectOne') }}
    </template>
  </v-multiselect>
</template>
<script>
export default {
  name: 'GenderInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    withNone: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      options: [
        { value: 1, text: this.$t('TemplateRisk.1'), color: '#2ECC40' },
        { value: 2, text: this.$t('TemplateRisk.2'), color: '#FF851B' },
        { value: 3, text: this.$t('TemplateRisk.3'), color: '#FF4136' },
        { value: 4, text: this.$t('TemplateRisk.4'), color: '#0074D9' },
      ]
    };
  },
  mounted() {
    if (this.withNone) {
      this.options.unshift(
        {
          value: 0,
          text: this.$t('common.None'),
          color: 'white'
        }
      );
    }
  },
  computed: {
    fieldModelValue: {
      get() {
        return (
          this.options.filter((x) => x.value === this.value)
          || this.options.filter((x) => x.value === 0)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.value);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
